"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressIndicator = ProgressIndicator;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    height: 100%;\n    display: flex;\n    align-items: center;\n    transition: width 0.4s;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    fill: ", ";\n    font-size: ", "rem;\n    font-family: Arial;\n    font-weight: bold;\n    text-align: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", "rem;\n    font-family: ", ";\n    font-weight: bold;\n    margin-left: ", ";\n    text-align: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ProgressBackgroundWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.colorObj.backgroundColor;
}, function (props) {
  return props.type === "bold" ? "24px" : "4px";
});

var ProgressTextWrapper = _styledComponents["default"].label(_templateObject2(), function (props) {
  return props.textColor;
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.type === "bold" ? props.spacingObj.margin + "px" : "0px";
});

var ProgressCircleTextWrapper = _styledComponents["default"].text(_templateObject3(), function (props) {
  return props.textColor;
}, function (props) {
  return props.spacingObj.fontSize;
});

var ProgressIndicatorWrapper = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.indicatorColor;
});
/**
 * Progress Indicators are used to display the percentage of completion of a task.
 * @example import { ProgressIndicator } from '@desktop/react';
 */


function ProgressIndicator(props) {
  var inherit = "progressIndicator";
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[inherit];
  var colors = context.getColors()[inherit];
  var progress = props.progress;

  if (progress > 100) {
    progress = 100;
  }

  var indicatorColor = props.indicatorColor ? props.indicatorColor : colors.defaultIndicatorColor;
  var textColor = props.type === "bold" ? 'white' : indicatorColor;

  function getProgressText() {
    return props.hideText ? null : /*#__PURE__*/_react["default"].createElement(ProgressTextWrapper, {
      textColor: textColor,
      indicatorColor: indicatorColor,
      spacingObj: spacing,
      style: props.textStyle,
      type: props.type,
      fontFamilyObj: context.getFont()
    }, progress + '%');
  }

  function getIndicator() {
    switch (props.type) {
      case 'circle':
        var lineWidth = spacing.lineWidth;
        var circleSize = props.circleSize - lineWidth;
        var elementSize = props.circleSize;
        var circumference = circleSize * Math.PI;
        var circleStyle = {
          fill: 'none',
          stroke: indicatorColor,
          strokeWidth: lineWidth + "px"
        };
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            height: elementSize + 'px',
            width: elementSize + 'px'
          }
        }, /*#__PURE__*/_react["default"].createElement("svg", {
          stroke: colors.indicatorColor,
          viewBox: "0 0 " + elementSize + " " + elementSize,
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react["default"].createElement("path", {
          className: "circle",
          strokeDasharray: circumference * (progress / 100) + ", " + circumference,
          d: "M " + (circleSize + lineWidth) / 2 + " " + lineWidth / 2 + " a " + circleSize / 2 + " " + circleSize / 2 + " 0 0 1 0 " + circleSize + " a " + circleSize / 2 + " " + circleSize / 2 + " 0 0 1 0 -" + circleSize,
          style: circleStyle
        }), props.hideText ? null : /*#__PURE__*/_react["default"].createElement(ProgressCircleTextWrapper, {
          spacingObj: spacing,
          textColor: textColor,
          textAnchor: "middle",
          x: "50%",
          y: circleSize / 2 + lineWidth + 2
        }, progress + '%')));

      case 'bold':
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(ProgressBackgroundWrapper, {
          type: props.type,
          style: props.style,
          colorObj: colors
        }, /*#__PURE__*/_react["default"].createElement(ProgressIndicatorWrapper, {
          indicatorColor: indicatorColor,
          style: _objectSpread({
            width: props.progress + '%'
          }, props.indicatorStyle)
        }, getProgressText())));

      default:
        return /*#__PURE__*/_react["default"].createElement("div", null, getProgressText(), /*#__PURE__*/_react["default"].createElement(ProgressBackgroundWrapper, {
          type: props.type,
          style: props.style,
          colorObj: colors
        }, /*#__PURE__*/_react["default"].createElement(ProgressIndicatorWrapper, {
          indicatorColor: indicatorColor,
          style: _objectSpread({
            width: props.progress + '%'
          }, props.indicatorStyle)
        })));
    }
  }

  return getIndicator();
}

ProgressIndicator.propTypes = {
  /**Extends the base styling of the progress indicator element. */
  style: _propTypes["default"].object,

  /**Extends the base styling of the progress indicator itself.  */
  indicatorStyle: _propTypes["default"].object,

  /**Extends the base styling of the text displaying the progress. */
  textStyle: _propTypes["default"].object,

  /**The percentage of the indicator that will be filled up. It is capped at 100. */
  progress: _propTypes["default"].number,

  /**Dictates the type of indicator used. Possible types are 'standard', 'bold' and 'circle'.*/
  type: _propTypes["default"].string,

  /**Hides the text which displays the progress prop. */
  hideText: _propTypes["default"].bool,

  /**Changes the color of the indicator. */
  indicatorColor: _propTypes["default"].string
};
ProgressIndicator.defaultProps = {
  style: {},
  indicatorStyle: {},
  textStyle: {},
  progress: 0,
  type: 'standard',
  hideText: false,
  indicatorColor: null,
  circleSize: 64
};